import * as React from "react";
import styled, { css } from "styled-components";
import { observer } from "mobx-react";
import { MainStore } from "app/stores/mainStore";
import { MetricsPanel } from "app/components/metricsPanel/MetricsPanel";

export const Panel = styled.div`
  ${(props: { size?: number }) => css`
    grid-column: span ${props.size ? props.size : 1};
    display: flex;
    justify-content: center;
    align-items: center;
  `};
`;
export const FallbackContainer = styled.div`
  ${(props: {}) => css`
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
  `};
`;
const IframePanel = styled.iframe`
  ${(props: { size?: number }) => css`
    width: 100%;
    grid-column: span ${props.size ? props.size : 1};
    align-self: stretch;
  `};
`;

const WallBoardView = styled.div`
  ${(props: {}) => css`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(2, 50vh);
    max-height: 100vh;
    iframe {
      border: none;
    }
  `};
`;

export interface Props {
  className?: string;
  store: MainStore;
}
export type DefaultPropsKeys = never;

const initialState = {};

type State = Readonly<typeof initialState>;

@observer
export class WallBoard extends React.Component<Props, State> {
  static defaultProps: Pick<Props, DefaultPropsKeys> = {};
  readonly state: State = initialState;

  render() {
    const { store } = this.props;
    return (
      <WallBoardView className={this.props.className}>
        {/*<Panel size={2}>
          <GooglePhotosFrame />
        </Panel>
        <IframePanel
          size={2}
          src="https://calendar.google.com/calendar/b/1/embed?showTitle=0&amp;showNav=0&amp;showDate=0&amp;showPrint=0&amp;showTabs=0&amp;showCalendars=0&amp;showTz=0&amp;mode=WEEK&amp;height=600&amp;wkst=1&amp;bgcolor=%23FFFFFF&amp;src=qwilt.com_f6894e14igqrisagdodjl7t0pk%40group.calendar.google.com&amp;color=%235F6B02&amp;ctz=Asia%2FJerusalem"
          scrolling="no"
        />*/}
        <IframePanel size={4} src={"https://maps.cqloud.com/presentation"} />
        {/*<IframePanel size={2} src={"https://directpoll.com/r?XDbzPBdEt8j1rJaGbyLOyiK4CoendzlKj4U3T6JzYse"} />*/}
        <MetricsPanel store={store} />
      </WallBoardView>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/wallBoard/WallBoard.tsx